import * as request from '@/utils/request'

/**
 * 自动生成 api代码【模块名：文件分片上传记录表】
 * 生成日期：2026/10/20 16:50:17
 * 生成路径: src/api/file_upload.js
 * 生成人：超级管理员
 */

/**
 * @description 获取列表
 * @param {*} data
 * @returns
 */
export function getFileUploadList(data) {
    return request.post('/file_upload/list', data)
}
/**
 * @description 保存
 * @param {*} data
 * @returns
 */
export function saveFileUpload(data) {
    return request.post('/file_upload/store', data)
}

/**
 * @description 获取详情
 * @param id
 * @returns
 */
export function getFileUploadInfo(id) {
    let data = { id: id }
    return request.post('/file_upload/get_info', data)
}

/**
 * @description 获取详情
 * @param where
 * @returns
 */
export function queryFileUploadInfo(where) {
    return request.post('/file_upload/query', where)
}

/**
 * @description 根据id删除单条信息
 * @param id
 * @returns
 */
export function deleteFileUpload(id) {
    let data = { id: id }
    return request.post('/file_upload/delete', data)
}

/**
 * 导入
 * @param data
 * @returns {Promise}
 */
export function importFileUploads(data) {
    return request.post('/file_upload/import', data)
}

/**
 * 导出
 * @param data
 * @returns {Promise}
 */
export function exportFileUploads(data) {
    return request.postBlob('/file_upload/export', data)
}

/**
 * 下载已上传完成的文件
 * @param id
 * @returns {Promise}
 */
export function downloadFileUpload(id) {
    const data = { id: id }
    return request.postBlob('/file_upload/download', data)
}
